module.exports = __webpack_public_path__ + "img/pdf.57483db4.png";